import type { FC } from "react";
import { useId } from "react";

import { Dropdown, DropdownButton, DropdownItem } from "@similarweb/ui-components";

import { type OperatorOption, operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import { StyledDDContainer, StyledDropdownButton } from "./styles";

type OperatorsDropdownProps = {
    options: readonly OperatorOption[];
    value?: OperatorOption;
    onChange: (value: OperatorOption) => void;
};

const OperatorsDropdown: FC<OperatorsDropdownProps> = ({ options, value, onChange }) => {
    const dropdownId = useId();
    const displayedValue = value ? value : operatorOptionMap.and;

    const handleClick = (item: { id: OperatorOption }): void => {
        onChange(item.id);
    };

    return (
        <StyledDDContainer id={dropdownId}>
            <Dropdown
                appendTo={`#${CSS.escape(dropdownId)}`}
                width={77}
                onClick={handleClick}
            >
                <StyledDropdownButton>
                    <DropdownButton width={77}>{displayedValue.toUpperCase()}</DropdownButton>
                </StyledDropdownButton>
                {...options.map((item) => {
                    return (
                        <DropdownItem
                            id={item}
                            key={item}
                        >
                            {item.toUpperCase()}
                        </DropdownItem>
                    );
                })}
            </Dropdown>
        </StyledDDContainer>
    );
};

export default OperatorsDropdown;
